<div class="modal1Main" [ngClass]="(isMac)?'macOS':'otherOS'">
  <div class="modalHeader">
    <span class="title">Swap Players In Multi League</span>
    <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  <div class="body">
    <ng-container>
      <div class="heading">
        <div class="playerinfo first">
          <span class="position">{{ curplayer.pick_rp }}</span>
          <div class="headshot" [ngStyle]="{'background-image':'url(\''+playerURL+curplayer.pic+'\')'}"></div>
          <div class="player-fn">
            {{ curplayer.fn }} {{ curplayer.ln }}
            <div class="player-ln">
              <span>{{ curplayer.tn | uppercase }}</span>
            </div>
          </div>
          <div class="projected">{{ curplayer.projFpts | number:'1.2-2'}}</div>
        </div>
        <div class="swap-out">
          <img src="assets/images/abc.gif">
          <!-- <img [src]="assetsURL+'default/images/swap_icon.svg'"> -->
        </div>
        <div class="playerinfo second">
          <span class="position">{{newplayer.id>0?newplayer.pn:''}}</span>
          <div class="headshot"
            [ngStyle]="{'background-image':'url(\''+playerURL+(newplayer.id>0?newplayer.pp:'default.png')+'\')'}"></div>
          <div class="player-fn">
            {{newplayer.id>0?newplayer.fn:'Select'}} {{newplayer.id>0?newplayer.ln:'Player'}}
            <div class="player-ln">
              <span>{{newplayer.id>0?newplayer.tn:'' | uppercase }}</span>
            </div>
          </div>
          <div class="projected">{{(newplayer.id>0?newplayer.prj:0) | number:'1.2-2'}}</div>
        </div>
      </div>
      <div class="info-heading" *ngIf="leaguesList.length>0 && otherLeagues.length==0">
        This same swap is also available in the following leagues. Multi-Swap?
      </div>
      <div class="info-heading" *ngIf="otherLeagues.length>0">
        You also own {{ curplayer.fn }} {{ curplayer.ln }} in the following leagues:
      </div>
      <div class="bottom-part" *ngIf="otherLeagues.length>0">
        <div class="leagueList">
          <div class="league-checkboxs league-list" *ngFor="let league of otherLeagues" (click)="goToLeague(league)">
            <div>{{league.name}}</div>
        </div>
        </div>
      </div>
      <div class="bottom-part scrollTable" *ngIf="leaguesList.length>0 && otherLeagues.length==0">
        <mat-checkbox class="select-all" [checked]="allLeaguesChecked" color="primary"
          [indeterminate]="indeterminate==true" (change)="checkAll($event.checked)">
          Select All
        </mat-checkbox>

        <div class="leagueList">
          <mat-checkbox class="league-checkboxs" *ngFor="let league of leaguesList" [(ngModel)]="league.checked"
            color="primary" (change)="checkLeague(league,$event.checked)">
            <div>{{league.name}}</div>
          </mat-checkbox>
        </div>
        <div *ngIf="leaguesList== ''" class="text-center minHeight150">No record found</div>
        <div class="confirm" >
          <mat-progress-bar *ngIf="showLoader" class="loadingBar" mode="buffer"></mat-progress-bar>
          <ng-container *ngIf="!showLoader">
            <button (click)="confirmMultiSwap()" [disabled]="!getcheckedList()" mat-raised-button color="primary" class="button confirmButton">
              Confirm Multi Swap</button>
            <a (click)="skipSwap()" mat-stroked-button class="button">
              Skip</a>
          </ng-container>
        </div>
      </div>

    </ng-container>
  </div>
</div>